/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * * `1` - Prejudicii cauzate autovehiculului
 * * `2` - Prejudicii cauzate altor bunuri
 * * `3` - Vătămări corporale, deces
 */
export enum DamageTypeEnum {
  '_1' = 1,
  '_2' = 2,
  '_3' = 3,
}
